import { memo } from 'react';
import { cn } from '../../../utils/string/cn.utils';

const ButtonIconSolidMedium = ({ id, icon, active = false, ...props }) => {
  return (
    <button
      id={id}
      type="button"
      {...props}
      className={cn(
        'disabled:cursor-not-allowed disabled:pointer-events-none bg-fills-white rounded-[100px] shadow-dropshadow8 flex justify-center items-center hover:bg-primary-primaryVariant1 hover:text-white-high disabled:text-black-low disabled:bg-fills-disable text-black-high',
        'gap-[10px] w-[32px] h-[32px] p-[6px] ',
        active && 'bg-primary-primary text-white-high',
        props.className
      )}
    >
      {icon && (
        <div className="w-20 h-20 flex justify-center items-center">{icon}</div>
      )}
    </button>
  );
};

export default memo(ButtonIconSolidMedium);
